import { Box, Link, Stack, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { WebRedirectIcon } from '../Svg-icons/App-Icons';

interface ContactInfo {
  websiteAddress: string | undefined;
}
const VisitWebSite = (props: ContactInfo) => {
  const theme: Theme = useTheme();
  return (
    <Box>
      <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
        <Typography variant="body2" sx={theme.custom.styles.phoneNumberAndWebSiteStyle}>
          <Link
            href={props.websiteAddress}
            target="_blank"
            sx={{
              textDecoration: 'none',
              color: `${theme.custom.colors.visitWebLinkColor}`,
              marginTop: '1.3rem',
            }}
          >
            {' Visit Website'}
          </Link>
        </Typography>
        <WebRedirectIcon fontSize="small" sx={{ color: `${theme.custom.colors.visitWebLinkColor}` }} />
      </Stack>
    </Box>
  );
};

export default VisitWebSite;
